import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * Smallest “stateful” UI without a framework: a closure holds `n`; the DOM (`#count`) is the view.
 * Pattern: read nodes once, update `textContent` on each click.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'counter',
  category: 'interaction',
  title: 'Counter button',
  description: 'Click the button to increment a stateful counter.',
  tags: [T.basics, T.counter, T.button],
  html: `<h1 data-testid="preset-counter-heading">Counter</h1>

<!-- Strong wraps the live value; JS replaces textContent so the number updates -->
<p>Count: <strong id="count">0</strong></p>

<button type="button" id="btn">Increment</button>`,
  css: `${shell}

h1 {
  color: var(--nogrok-preview-primary);
  font-size: 1.25rem;
  margin: 0 0 0.75rem;
}

p {
  margin: 0 0 1rem;
}

button {
  font: inherit;
  padding: 0.5rem 1rem;
  border: 1px solid var(--nogrok-preview-primary);
  background: color-mix(in srgb, var(--nogrok-preview-primary) 13%, transparent);
  color: var(--nogrok-preview-on-surface);
  border-radius: 6px;
  cursor: pointer;
}

/* Slight brightening on hover gives affordance without extra markup */
button:hover {
  background: color-mix(in srgb, var(--nogrok-preview-primary) 20%, transparent);
}`,
  js: `// State lives here (not in the DOM). Could use data-* or a span only; this keeps the script tiny.
let n = 0
const count = document.getElementById('count')
const btn = document.getElementById('btn')

btn?.addEventListener('click', () => {
  n += 1
  // One source of truth → push to the label
  if (count) count.textContent = String(n)
})`,
}

export default preset
